import { useNavigate } from "react-router-dom";
import { APP_ROUTES, FILTER_KEY } from "config";
import React, { ReactText } from "react";

type EntityPageLinkProps = {
  buttonText: string;
  filterStringFieldName: string;
  destinationPage: APP_ROUTES;

  selectedId: string | undefined;
};

const EntityPageLink: React.FC<EntityPageLinkProps> = ({
  buttonText,
  filterStringFieldName,
  destinationPage,
  selectedId,
}) => {
  const handleClick = () => {
    const navigate = useNavigate();

    if (selectedId && filterStringFieldName && destinationPage) {
      const filterString = `${filterStringFieldName} EQ (${selectedId})`;
      window.localStorage.setItem(FILTER_KEY, filterString);

      navigate(destinationPage);
    }
  };

  return (
    <div>
      <div className="EntityPageLink Btn" onClick={handleClick}>
        {buttonText}
      </div>
    </div>
  );
};

export default EntityPageLink;
